module.exports = __webpack_public_path__ + "media/images/help-a382327205eb4a561ec60d3baabe8de5.svg";